import React, { useState } from "react";

import Typography from "@mui/material/Typography";

import BillingLinkButton from "@app/analytics/account/Billing/components/BillingLinkButton";
import { buildEmailMailtoLink } from "@app/analytics/account/Billing/utils";
import LeaveConfirmationModal from "@app/analytics/components/LeaveConfirmationModal";
import { useAuthenticated } from "@app/common/auth/useAuth";
import ROUTES from "@app/common/routes";
import type { Client } from "@app/common/types";
import useWorkspace from "@app/common/workspaces/useWorkspace";

import Link from "@rui/Link";
import { Row } from "@rui/Stack";

const NonAdminCurrentPlanActions = ({ client }: { client: Client }) => {
  const { user } = useAuthenticated();
  const { workspace, leaveWorkspace } = useWorkspace();
  const workspaceOwner = workspace.users.find((u) => u.role === "owner")!;

  const [leaveWorkspaceModalOpen, setLeaveWorkspaceModalOpen] = useState(false);

  const handleRequestUpgrade = () => {
    return (location.href = `mailto:${buildEmailMailtoLink(
      workspaceOwner!,
      user!
    )}`);
  };

  return (
    <>
      <LeaveConfirmationModal
        loading={leaveWorkspace.isPending}
        open={leaveWorkspaceModalOpen}
        onClose={() => setLeaveWorkspaceModalOpen(false)}
        onConfirm={() => leaveWorkspace.mutate()}
        context="workspace"
      />
      {client === "zoom" ? (
        <Typography>
          To manage your billing information,{" "}
          <Link href={ROUTES.BILLING} sx={{ fontWeight: 500 }}>
            open in the browser
          </Link>
          .
        </Typography>
      ) : (
        <Row spacing={1}>
          <BillingLinkButton
            onClick={handleRequestUpgrade}
            testId="billing-request-upgrade-button"
          >
            Request upgrade
          </BillingLinkButton>
          <BillingLinkButton
            color="error"
            variant="text"
            onClick={() => setLeaveWorkspaceModalOpen(true)}
          >
            Leave Workspace
          </BillingLinkButton>
        </Row>
      )}
    </>
  );
};

export default NonAdminCurrentPlanActions;
